import React from 'react';
import { mockParking } from '../../../services/mockData';

const ParkingReport = () => (
  <div className="fade-in">
    <div className="page-header">
      <div className="breadcrumb">Society Reports <span>/ Parking Report</span></div>
      <h2>Parking Report</h2>
    </div>

    <div className="filter-bar">
      <div className="form-group">
        <label>Member</label>
        <select className="form-control">
          <option>Select</option>
          {Array.from(new Set(mockParking.map(p => p.flatNo))).map(f => (
            <option key={f}>{f}</option>
          ))}
        </select>
      </div>
      <div className="form-group" style={{ marginLeft: 'auto', justifyContent: 'flex-end' }}>
        <div className="btn-group">
          <button className="btn btn-primary">Get All</button>
          <button className="btn btn-warning btn-sm">🖨️ Print</button>
          <button className="btn btn-success btn-sm">📊 Export To Excel</button>
        </div>
      </div>
    </div>

    <div className="card">
      <div className="report-header" style={{ marginBottom: '16px' }}>
        <h3>Vitthal Plaza Co-Op Housing Society LTD</h3>
        <p>Registration Number: TNADO(M/HSG/TC)/25796/YEAR-2023 | dr Sagar(Dombivali)</p>
        <p style={{ fontWeight: '700', marginTop: '6px' }}>Parking Report — On dated: 2026-02-02</p>
      </div>

      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Flat No</th>
              <th>Slot No</th>
              <th>Sticker No</th>
              <th>Model</th>
              <th>Number</th>
              <th>Vehicle Type</th>
              <th>Slot Type</th>
              <th>Parking Type</th>
            </tr>
          </thead>
          <tbody>
            {mockParking.map((p, i) => (
              <tr key={i}>
                <td><span className="badge badge-primary">{p.flatNo}</span></td>
                <td>{p.slotNo}</td>
                <td>{p.stickerNo}</td>
                <td>{p.model || '—'}</td>
                <td>{p.number || '—'}</td>
                <td>
                  <span className={`badge ${p.vehicleType === '4-Wheeler' ? 'badge-primary' : 'badge-secondary'}`}>
                    {p.vehicleType}
                  </span>
                </td>
                <td>{p.slotType || '—'}</td>
                <td>
                  <span className={`badge ${p.parkingType === 'Owned' ? 'badge-success' : p.parkingType === 'Allotted' ? 'badge-warning' : 'badge-secondary'}`}>
                    {p.parkingType}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default ParkingReport;
